import React from 'react'

const H2 = (props) => <h2 {...props} />

export default H2
